import { useState } from "react";
import { IMAGE_URL } from "../../../path";

type Props = {
    bestServedWith?: any;
    onClose: () => void;
    onSave: (
        data: FormData
    ) => void;
};

export default function BestServedWithModal({
                                                bestServedWith,
                                                onClose,
                                                onSave,
                                            }: Props) {
    const [name, setName] =
        useState(
            bestServedWith?.name ||
            ""
        );

    const [icon, setIcon] =
        useState<File | null>(
            null
        );

    const [
        iconPreview,
        setIconPreview,
    ] = useState(
        bestServedWith?.icon || ""
    );

    const [
        isActive,
        setIsActive,
    ] = useState(
        bestServedWith?.is_active ??
        true
    );

    const getImageUrl = (
        path?: string
    ) => {
        if (!path) return "";

        if (
            path.startsWith(
                "http"
            ) ||
            path.startsWith(
                "blob:"
            )
        ) {
            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const handleSubmit = (
        e: React.FormEvent
    ) => {
        e.preventDefault();

        const formData =
            new FormData();

        formData.append(
            "name",
            name
        );

        formData.append(
            "is_active",
            isActive
                ? "1"
                : "0"
        );

        if (icon) {
            formData.append(
                "icon",
                icon
            );
        }

        onSave(formData);
    };

    return (
        <div
            className="modal-overlay"
            onClick={onClose}
        >
            <div
                className="modal-box"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >
                <h2>
                    {bestServedWith
                        ? "Edit Best Served With"
                        : "Add Best Served With"}
                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >
                    <label>
                        Name
                    </label>

                    <input
                        type="text"
                        value={name}
                        onChange={(e) =>
                            setName(
                                e.target
                                    .value
                            )
                        }
                        required
                    />

                    <label>
                        Icon
                    </label>

                    {iconPreview && (
                        <img
                            src={getImageUrl(
                                iconPreview
                            )}
                            alt=""
                            className="image-preview"
                        />
                    )}

                    <p className="field-hint">
                        Maximum file
                        size: 2MB
                    </p>

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(
                            e
                        ) => {
                            const file =
                                e.target
                                    .files?.[0];

                            if (
                                !file
                            )
                                return;

                            if (
                                file.size >
                                2 *
                                1024 *
                                1024
                            ) {
                                alert(
                                    "Image must be 2MB or smaller."
                                );
                                return;
                            }

                            setIcon(
                                file
                            );

                            setIconPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );
                        }}
                    />

                    <label>
                        Active
                    </label>

                    <select
                        value={
                            isActive
                                ? "1"
                                : "0"
                        }
                        onChange={(
                            e
                        ) =>
                            setIsActive(
                                e
                                    .target
                                    .value ===
                                "1"
                            )
                        }
                    >
                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>
                    </select>

                    <div className="modal-actions">
                        <div className="left-actions">
                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>
                        </div>

                        <div className="right-actions">
                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
